import { applicationListStateName } from 'modules/application/list';
import { tenantInvitationRequestSentStateName, inviteMemberTenantName } from 'modules/application/tenant';
import { debounce } from 'data/function';
import { ORGANIZATION_CREATE_TENANT_CANCEL_BUTTON, } from '../TenantSegmentEvents';
const ORGANIZATION_NAME_MIN_LENTH = 3;
export class CreateTenantController {
    static $inject = ['TenantService', 'AccountService2', 'BlipService', 'AuthenticationService', '$state', '$translate', 'SegmentService', '$stateParams', 'BlipToastService', 'SharedToastsService'];
    constructor(TenantService, AccountService2, BlipService, AuthenticationService, $state, $translate, SegmentService, $stateParams, BlipToastService, SharedToastsService) {
        'ngInject';
        this.TenantService = TenantService;
        this.AccountService2 = AccountService2;
        this.BlipService = BlipService;
        this.AuthenticationService = AuthenticationService;
        this.$state = $state;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.$stateParams = $stateParams;
        this.BlipToastService = BlipToastService;
        this.SharedToastsService = SharedToastsService;
        this.loading = false;
        this.haveUsedAnyTenant = false;
        this.onInputChange = async (event) => {
            this.organizationName = event.target.value;
            await this.setupValidId();
        };
        this.createTenant = async () => {
            if (!(await this.formElementRef.isValid())) {
                return;
            }
            const tenantUrl = this.TenantService.getTenantUrl(this.organizationId);
            try {
                this.creatingTenant = true;
                this.toastInfoClose();
                const tenant = {
                    id: this.organizationId,
                    name: this.organizationName,
                };
                await this.TenantService.set(tenant);
                await this.trackTenantCreation(tenantUrl, 'success');
                this.$state.go(inviteMemberTenantName, {
                    tenantId: this.organizationId,
                    tenantName: this.organizationName,
                });
            }
            catch (e) {
                console.error('*** create tenant error: ', e);
                const title = await this.$translate('create-tenant.errorFailedToProcessTitle');
                const msg = await this.$translate('create-tenant.errorFailedToProcess');
                this.BlipToastService.show('danger', {
                    title,
                    msg,
                });
                await this.setupValidId();
                await this.trackTenantCreation(tenantUrl, 'failed');
            }
            finally {
                this.creatingTenant = false;
            }
        };
        this.createTenantNew = async () => {
            const isValid = await this.formElementRef.isValid();
            if (!(isValid)) {
                return;
            }
            const tenantUrl = this.TenantService.getTenantUrl(this.organizationId);
            try {
                this.creatingTenant = true;
                this.toastInfoClose();
                const tenant = {
                    id: this.organizationId,
                    name: this.removeSpaceDuplicate(this.organizationName),
                };
                const existingTenant = await this.TenantService.existingTenant(tenant.id);
                if (existingTenant != undefined) {
                    return this.BlipToastService.show('warning', {
                        title: await this.$translate('create-tenant.errorUsedTenantNameTitle'),
                        msg: await this.$translate('create-tenant.errorUsedTenantName'),
                    });
                }
                await this.TenantService.setTenantNew(tenant);
                await this.TenantService.setTenantUserDefaultContract(tenant);
                await this.trackTenantCreation(tenantUrl, 'success');
                this.$state.go(inviteMemberTenantName, {
                    tenantId: this.organizationId,
                    tenantName: this.organizationName,
                });
            }
            catch (e) {
                console.error('*** create tenant error: ', e);
                const title = await this.$translate('create-tenant.errorFailedToProcessTitle');
                const msg = await this.$translate('create-tenant.errorFailedToProcess');
                this.BlipToastService.show('danger', {
                    title,
                    msg,
                });
                await this.setupValidId();
                await this.trackTenantCreation(tenantUrl, 'failed');
            }
            finally {
                this.creatingTenant = false;
            }
        };
        this.toastInfoClose = () => {
            const toastContainer = document.querySelector('bds-toast-container');
            if (toastContainer && toastContainer.childElementCount > 0) {
                (toastContainer.firstElementChild).close();
            }
        };
        this.askToJoinTenant = async () => {
            try {
                this.setFormValid(false);
                await this.TenantService.joinTenant(this.tenantId);
                this.toastInfoClose();
                this.$state.go(tenantInvitationRequestSentStateName, {
                    id: this.tenantId,
                    name: this.tenantName,
                });
            }
            catch (e) {
                await this.formElementRef.isValid();
                console.error('*** askToJoinTenant error: ', e);
                const msg = await this.$translate('create-tenant.genericError');
                this.BlipToastService.show('danger', {
                    msg,
                });
            }
        };
        const { id, name } = this.$stateParams;
        this.creatingTenant = false;
        this.tenantId = id;
        this.tenantName = name;
        this.formElementRef = {};
        debounce(this.setupValidId, 300);
    }
    async $onInit() {
        await this.connect();
        this.formElementRef = {
            organizationName: {
                ref: document.querySelector('bds-input[field-name="organization"]'),
            },
            isValid: async () => {
                const isValid = await this.formElementRef.organizationName.ref.isValid();
                this.setFormValid(isValid);
                return (isValid);
            },
        };
        await this.setupValidId(true);
        if (this.tenantName) {
            const msg = await this.$translate('create-tenant.alreadyHasOrganization', {
                tenantName: this.tenantName,
            });
            const buttonText = await this.$translate('create-tenant.clickHere');
            this.BlipToastService.show('info', {
                msg,
                buttonText,
                callback: this.askToJoinTenant,
                duration: 6000,
                position: 'bottom-right',
            });
        }
        await this.SharedToastsService.showLeaveContractToast();
    }
    replaceSpecialChars(str) {
        return str
            .replace(/[áàâã]/g, 'a')
            .replace(/[éèê]/g, 'e')
            .replace(/[íìî]/g, 'i')
            .replace(/[óòûõ]/g, 'o')
            .replace(/[úùû]/g, 'u')
            .replace(/[ç]/g, 'c');
    }
    removeSpaceDuplicate(organizationName) {
        return organizationName
            .replace(/( )+/g, ' ')
            .trim();
    }
    removeSpaceChars(organizationName) {
        const organizationId = this.removeSpaceDuplicate(organizationName);
        return this.replaceSpecialChars(organizationId
            .toLowerCase()
            .replace(/\s/g, ''));
    }
    async setupValidId(isFirstCall = false) {
        await this.formElementRef.isValid();
        if (!isFirstCall &&
            (!this.organizationName || this.organizationName.length < ORGANIZATION_NAME_MIN_LENTH)) {
            return;
        }
        this.loading = true;
        const { email, extras } = await this.AccountService2.me();
        try {
            this.organizationId = !isFirstCall && this.removeSpaceChars(this.organizationName);
            if (isFirstCall) {
                this.organizationName = this.AccountService2.getEmailDomain(email);
                const lastUsedTenantsExtra = extras && extras.lastUsedTenants || '[]';
                const lastUsedTenants = [...JSON.parse(lastUsedTenantsExtra).filter((t) => t !== '')];
                this.haveUsedAnyTenant = lastUsedTenants.length > 0;
            }
        }
        catch (e) {
            console.error(e);
        }
        finally {
            await this.formElementRef.isValid();
            this.loading = false;
        }
    }
    async connect() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
    trackTenantCreation(tenantUrl, status) {
        return this.SegmentService.createTrack('organization-create', {
            organizationName: this.organizationName,
            organizationUrl: tenantUrl,
            status,
        });
    }
    async cancelClick() {
        this.loading = true;
        const user = await this.AccountService2.me();
        const emailDomain = this.AccountService2.getEmailDomain(user.email);
        await this.SegmentService.createTrack(ORGANIZATION_CREATE_TENANT_CANCEL_BUTTON, {
            emailDomain: emailDomain,
            userId: user.identity,
        });
        this.toastInfoClose();
        this.$state.go(applicationListStateName);
    }
    setFormValid(isValid = false) {
        this.createTenantForm.$valid = isValid;
        this.createTenantForm.$invalid = !this.createTenantForm.$valid;
    }
}
CreateTenantController.$inject = ['TenantService', 'AccountService2', 'BlipService', 'AuthenticationService', '$state', '$translate', 'SegmentService', '$stateParams', 'BlipToastService', 'SharedToastsService'];
